//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MescrollVue from 'mescroll.js/mescroll.vue'
import {queryuserorder} from '../../../api/pay'
export default {
  name: 'userOrder',
  components: {
    MescrollVue // 注册mescroll组件
  },
  data () {
    return {
      start: '',
      end: '',
      textTime: '',
      timeInfo: new Date(),
      showTimeOpen: false,
      maxDate: new Date(2025, 10, 1),
      showNo: false,
      listLog: [],
      mescrollUp: { // 上拉加载的配置.
        callback: this.upCallback,
        isBoth: true,
        dataList: [] // 列表数据
      }
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let moth = parseInt(new Date().format('MM')) - 1
    let showMoth = moth
    if (moth < 10) {
      showMoth = '0' + moth
    }
    this.maxDate = new Date(new Date().format('yyyy'), showMoth, new Date().format('dd'))
    this.textTime = new Date().format('yyyy-MM')
    console.log(this.textTime)
  },
  methods: {
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit (mescroll) {
      this.mescroll = mescroll // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    getDay (year, month) {
      let day31 = ['1', '3', '5', '7', '8', '10', '12']
      let day30 = ['4', '6', '9', '11']
      let day = ''
      if (day31.indexOf(month) > -1) {
        day = '31'
      } else if (day30.indexOf(month) > -1) {
        day = '30'
      } else {
        // eslint-disable-next-line no-mixed-operators
        if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
          day = '29'
        } else {
          day = '28'
        }
      }
      return day
    },
    getStartEnd () {
      let changeTime = [this.textTime.split('-')[0], parseInt(this.textTime.split('-')[1]) + '']
      let year = new Date().getFullYear() + ''
      let month = new Date().getMonth() + 1 + ''
      let day = new Date().getDate() + ''
      let endMonth = changeTime[1].length === 1 ? '0' + changeTime[1] : changeTime[1]
      let endDay = this.getDay(changeTime[0], changeTime[1])
      if (changeTime[0] === year && changeTime[1] === month) {
        let today = day.length === 1 ? '0' + day : day
        this.start = changeTime[0] + '-' + endMonth + '-01'
        this.end = this.common.GetDateStr(1, changeTime[0] + '-' + endMonth + '-' + today)
      } else {
        this.start = changeTime[0] + '-' + endMonth + '-01'
        this.end = this.common.GetDateStr(1, changeTime[0] + '-' + endMonth + '-' + endDay)
      }
    },
    upCallback (page, mescroll) {
      this.getStartEnd()
      let data = {
        phone: this.$store.getters.get_user,
        from: this.start,
        to: this.end
      }
      let params = {
        page: parseInt(page.num),
        size: 20
      }
      queryuserorder(params, data).then(res => {
        if (res.code === 200) {
          if (res.data) {
            let userorder = res.data.userorder
            let arr = []
            for (let i = 0; i < userorder.length; i++) {
              let obj = userorder[i]
              obj.typeName = '其他'
              obj.contentName = ''
              if (userorder[i].order_type.slice(0, 3) === 'sms') {
                obj.typeName = '短信充值'
                obj.contentName = parseInt(userorder[i].order_type.slice(3)) + '条短信'
              } else if (userorder[i].order_type.slice(0, 5) === 'voice') {
                obj.typeName = '语音充值'
                obj.contentName = parseInt(userorder[i].order_type.slice(5)) + '条语音'
              } else if (userorder[i].order_type.slice(0, 4) === 'push') {
                obj.typeName = '短信和语音充值'
                obj.contentName = parseInt(userorder[i].order_type.slice(4)) / 2 + '条短信' + parseInt(userorder[i].order_type.slice(4)) / 2 + '条语音'
              }
              arr.push(obj)
            }
            if (page.num === 1) {
              this.listLog = arr
            } else {
              this.listLog = this.listLog.concat(arr)
            }
            if (this.listLog.length === 0) {
              this.showNo = true
            } else {
              this.showNo = false
            }
          }
        }
        let vm = this
        this.$nextTick(() => {
          setTimeout(() => {
            vm.mescroll.endSuccess(this.listLog.length)
          }, 100)
        })
      }).catch(() => {
        let vm = this
        this.$nextTick(() => {
          setTimeout(() => {
            vm.mescroll.endSuccess(0)
          }, 100)
        })
      })
    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },
    onConfirm (time) {
      this.textTime = time.format('yyyy-MM')
      this.showTimeOpen = false
      let page = {num: 1, size: 10}
      this.upCallback(page)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/more/compoments/userOrder.vue